import React from 'react';
import './App.css';
import Quoter from './components/Quoter';
// import InsuranceButtons from './components/InsuranceButtons';
// import TravelForm from './components/TravelForm';

function App() {
  return (
    <div className="QuoterApp">
      <div style={{ position: 'relative', width: '100%', marginTop: '30px' }}>
        <Quoter />
      </div>
      {/* <TravelForm /> */}
    </div>
  );
}

export default App;
